// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockFilledSvg from "@fishx/icons-svg/es/asn/UnlockFilled";
import FishxIcon from '../components/FishxIcon';

var UnlockFilled = function UnlockFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockFilledSvg
  }));
};

UnlockFilled.displayName = 'UnlockFilled';
export default React.forwardRef(UnlockFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UnlockFilled.js
// module id = 4312
// module chunks = 0